import React from 'react';
import PhotoCapture from './PhotoCapture';
import { useNavigate } from 'react-router-dom';

interface PhotoCaptureContainerProps {
  onClose?: () => void;
}

const PhotoCaptureContainer: React.FC<PhotoCaptureContainerProps> = ({ onClose }) => {
  const navigate = useNavigate();

  // Handle close - navigate back to previous page
  const handleClose = () => {
    if (onClose) {
      onClose();
    } else {
      navigate(-1);
    }
  };

  // Simply render PhotoCapture component which handles everything internally
  return (
    <PhotoCapture
      onClose={handleClose}
    />
  );
};

export default PhotoCaptureContainer;
